import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerTurnovers from './ReportCustomerTurnovers'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:month?`} component={ReportCustomerTurnovers} />
    </Switch>
)

export default Components
